import isEqual from 'lodash.isequal';
import mapValues from 'lodash.mapvalues';
import pick from 'lodash.pick';

// Local Types
import { State, StateDiff } from './types';

const statePickFields = (state: State, fieldWhitelist?: string[]): State => {
    if (!fieldWhitelist) {
        return state;
    }
    return mapValues(state, value => pick(value, fieldWhitelist));
};

/**
 * Takes two version of the same redux state.
 * And returns an object with the created, deleted and updated differences.
 * @param oldState - The old version of the state
 * @param newState - The new version of the state
 * @param fieldWhitelist - An optional list of fields that you want diffed
 */
const stateDiff = (
    oldState: State,
    newState: State,
    fieldWhitelist?: string[]
): StateDiff | undefined => {
    const initalState = statePickFields(oldState, fieldWhitelist);
    const state = statePickFields(newState, fieldWhitelist);

    const initalStateKeys = Object.keys(initalState);
    const stateKeys = Object.keys(state);

    const createdValuesKeys = stateKeys.filter(
        key => !initalStateKeys.includes(key)
    );
    const deletedValuesKeys = initalStateKeys.filter(
        key => !stateKeys.includes(key)
    );
    const otherValuesKeys = stateKeys.filter(key =>
        initalStateKeys.includes(key)
    );
    const updatedValuesKeys = otherValuesKeys.filter(
        // @ts-ignore
        key => !isEqual(initalState[key], state[key])
    );

    const hasCreates = createdValuesKeys.length;
    const hasUpdates = updatedValuesKeys.length;
    const hasDeletes = deletedValuesKeys.length;

    if (hasCreates || hasUpdates || hasDeletes) {
        const create = createdValuesKeys.map((key: string) => {
            const value = state[key];
            return value;
        });

        const update = updatedValuesKeys.map((key: string) => {
            const value = state[key];
            return value;
        });

        const diff = {
            create,
            update,
            delete: deletedValuesKeys
        };

        return diff;
    }
    return undefined;
};

export default stateDiff;
